import { useMemo } from 'react';
import { PaymentPlanModel } from '@frontend/api-payment-plans';
import { useTranslation } from '@frontend/i18n';
import { Photos } from '@frontend/photos';
import { useNavigate } from '@frontend/weave-router';
import { usePaymentPlansSearchInfiniteQuery } from '../../../hooks/use-payment-plan-search';
import { usePaymentPlanShallowStore } from '../../../providers/payment-plans-provider';
import { SmallInfiniteTableView } from '../../SmallTableView/small-infinite-table-view';
import { getSmallViewTableColumns } from '../../SmallTableView/utils';
import { generateColumns } from './generate-columns';
import { RowHeader } from './row-header';

export const PaymentPlanMobileList = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('payments');
  const columns = useMemo(() => generateColumns, []);
  const infiniteQueryProps = usePaymentPlansSearchInfiniteQuery();
  const { setSelectedPaymentPlan } = usePaymentPlanShallowStore('setSelectedPaymentPlan');

  // @ts-ignore
  const filteredColumns = columns.filter((col) => col.id !== 'person' && col.id !== 'status');

  return (
    <SmallInfiniteTableView
      infiniteQueryProps={infiniteQueryProps}
      emptyStateConfig={{ type: 'payments', header: t('No data to display') }}
      startColumn={(paymentPlan: PaymentPlanModel) => (
        <Photos.ContactProfilePhoto
          name={`${paymentPlan.person.firstName} ${paymentPlan.person.lastName}`}
          personId={paymentPlan.person?.id}
          locationId={paymentPlan.locationId}
          size='small'
        />
      )}
      rowHeader={(paymentPlan) => <RowHeader paymentPlan={paymentPlan} />}
      colConfig={getSmallViewTableColumns(filteredColumns)}
      onRowClick={(paymentPlan: PaymentPlanModel) => {
        setSelectedPaymentPlan(paymentPlan);
        navigate({ to: '/payments/payment-plans/$planId', params: { planId: paymentPlan.id } });
      }}
    />
  );
};
